import { NimmstaLayout } from './NimmstaLayout';
const SUCCESS_LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="Success Layout">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar/>
                <icon horizontalAlignment="center" y="50" name="success_tick" align="c" />
                <cell horizontalAlignment="center" fontSize="17" wrapMode="wrap" maxLines="0" name="text"></cell>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>`;
export class SuccessLayout extends NimmstaLayout {
    constructor(text) {
        super(SUCCESS_LAYOUT, { text });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VjY2Vzc0xheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2xheW91dHMvU3VjY2Vzc0xheW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFaEQsTUFBTSxjQUFjLEdBQUc7Ozs7Ozs7Ozs7O2lCQVdOLENBQUM7QUFLbEIsTUFBTSxPQUFPLGFBQWMsU0FBUSxhQUFhO0lBQzlDLFlBQVksSUFBWTtRQUN0QixLQUFLLENBQUMsY0FBYyxFQUFFLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztJQUNsQyxDQUFDO0NBQ0YifQ==